// import components
import Box from '@mui/material/Box';
import { Tab, Tabs } from '@mui/material';
import { StyledUnsavedDataAlertBox } from 'components/shared/CRUD/components/InnerPage/EditPage.styles';
import UnsavedDataAlert from 'components/shared/CRUD/components/InnerPage/components/UnsavedDataAlert';
import TabRenderer from './TabRenderer';

// import hooks
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { TabType } from 'components/admin-portal/Authorization/Grants/components/edit/types';
import { EditPageProps } from './types';

// imports external libraries
import { AnimatePresence } from 'motion/react';

const EditTabs: React.FC<EditPageProps> = ({
  toggleInnerLayout,
  rowData,
  rows
}) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'authorizationSettings.edit.sectionTitles'
  });
  const [value, setValue] = useState<TabType>(TabType.GENERAL);

  const [isNavigationDisabled, setIsNavigationDisabled] = useState(false);

  const [currentViewData, setCurrentViewData] = useState(rowData);

  const [isDirty, setIsDirty] = useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: TabType) => {
    setValue(newValue);
  };

  return (
    <Box paddingY={2}>
      <Tabs value={value} onChange={handleChange}>
        {Object.values(TabType).map((tabItem, index) => {
          return (
            <Tab
              key={index}
              value={tabItem}
              label={t(tabItem)}
              disabled={isNavigationDisabled}
              component="a"
            />
          );
        })}
      </Tabs>
      <AnimatePresence mode="wait">
        {isDirty && (
          <StyledUnsavedDataAlertBox
            key="motion-unsaved-edit-tabs"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <UnsavedDataAlert />
          </StyledUnsavedDataAlertBox>
        )}
      </AnimatePresence>

      <TabRenderer
        rows={rows}
        currentTab={value}
        toggleInnerLayout={toggleInnerLayout}
        setIsNavigationDisabled={setIsNavigationDisabled}
        currentViewData={currentViewData}
        setCurrentViewData={setCurrentViewData}
        setIsDirty={setIsDirty}
      />
    </Box>
  );
};

export default EditTabs;
